import React from "react";
import "./Popular_Experts.css";
import Common_Expert_Card from "../../../common_components/common-expert-card/Common_Expert_Card";
import Common_Headings from "../../../common_components/common_heading/Common_Headings";

const expertData = [
  {
    id: 1,
    name: "Rahul Shinde",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 2,
    name: "Omkar Yadav",
    location: "Pune, Maharashtra",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 3,
    name: "Ritesh Deshmukh",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
];

const Popular_Experts = () => {
  return (
    <div className="container mt-4 vendor-section">
      <Common_Headings title="POPULAR EXPERT" />

      <div className="row">
        {expertData.map((expert) => (
          <div
            key={expert.id}
            className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
          >
            <Common_Expert_Card data={expert} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular_Experts;
